import React from 'react';
import { Bubble } from '@lt/components';
import { QuestionOutline } from '@lt/components/icons-react/rebrand';
import type { ILabel } from '@lt/components/components/Label';
import classnames from 'classnames';
import styles from './FlightsLabelItem.module.css';

export interface IFlightsLabel
  extends Omit<ILabel, 'icon_path' | 'description'> {
  icon_path?: string | null;
  description?: string;
  checkout_layout?: number | null;
}

interface FlightsLabelItemProps {
  label: IFlightsLabel;
  isMobile?: boolean;
}

const CASHBACK_LABEL_IDS = [784, 785];

export const FlightsLabelItem: React.FC<FlightsLabelItemProps> = ({
  label,
  isMobile = false,
}) => {
  const { id, icon_path: iconPath, title, description } = label;

  /* 
  применяем салатовый цвет и показываем иконку только для лейблов с повышенным кешбеком
  поэтому завязывается на id, а не на style === 6, 
  поскольку есть другие лейблы с таким же style
*/
  const isExtraCashbackLabel = CASHBACK_LABEL_IDS.includes(Number(id));
  const shouldShowIcon = iconPath && isExtraCashbackLabel;

  return (
    <Bubble className={styles.bubble} text={description}>
      <div
        key={id}
        className={classnames(
          styles.label,
          isMobile && styles.labelMobile,
          isExtraCashbackLabel && styles.limeGreen,
        )}
      >
        {shouldShowIcon && (
          <div
            className={styles.icon}
            style={{ backgroundImage: `url(${iconPath})` }}
          />
        )}
        <span className={styles.title}>{title}</span>
        {description && <QuestionOutline className={styles.questionIcon} />}
      </div>
    </Bubble>
  );
};
